import { NavLink } from "react-router-dom";
import styles from "../styles/sidebar/CategoryList.module.css";
import { paths } from "../../constants/paths";
import { normalizePath } from "../../helpers/pathUtils";


interface Category {
  heading: string;
  id: string;
  link?: string;
}

interface CategoryListProps {
  heading: string;
  categories: Category[];
}

const CategoryList = ({ heading, categories }: CategoryListProps) => {
  return (
    <div className={styles.categoryList}>
      <h3 className={styles.categoryTitle}>{heading}</h3>
      <ul className={styles.categoriesContainer}>
        {categories?.map(({ heading: itemHeading, id, link }) => (
          <li key={id} className={styles.categoryItem}>
            {link ? (
              <a
                href={link}
                className={styles.categoryButton}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className={styles.categoryName}>{itemHeading}</span>
              </a>
            ) : (
              <NavLink
                to={normalizePath(`${paths.servicesPage}${id}`)}
                className={`${styles.categoryButton}`}
              >
                <span className={styles.categoryName}>{itemHeading}</span>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryList;
